import React, { useState } from 'react';
import { Mail, MessageCircle, HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const Support = () => {
    const [openFaq, setOpenFaq] = useState(null);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const faqs = [
        {
            question: "Wie starte ich eine neue Spielanalyse?",
            answer: "Öffne die App und tippe auf den '+' Button. Wähle dein Team aus oder erstelle ein neues Team. Anschließend kannst du direkt mit der Live-Analyse beginnen."
        },
        {
            question: "Wie funktioniert das Team-Sharing mit Co-Trainern?",
            answer: "Generiere einen QR-Code in den Einstellungen der Scouting Ansciht und lasse deinen Co-Trainer diesen scannen. Dein Co-Trainer kann den über den QR-Code Button unten rechts scannen. Er kann dann in Echtzeit mitanalysieren und sieht alle Statistiken live."
        },
        {
            question: "Wie erstelle ich ein Team?",
            answer: "Wechsel auf der Startseite in den Teams Tab und erstelle dort ein Team. Füge den Team Spieler hinzu mit einem Namen und/oder Nummer und optional einer Position. Durch die Angabe der Position kann die App dir intelligentere Vorschläge geben."
        },
        {
            question: "Funktioniert VolleyScout offline?",
            answer: "Aktuell funktioniert die Dateneingabe offline noch nicht, da der Fokus auf die Synchronisierung mit anderen Geräten liegt."
        },
        {
            question: "Wie sehe ich die Statistiken des gesamten Spiel?",
            answer: "Am Ende, wenn das Spiel beendet wurde kannst du über einen Button in der Scouting Ansicht die Statistiken einsehen."
        }
    ];
    return (
        <div style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            background: 'linear-gradient(135deg, #171B27 0%, #0F121C 100%)',
            color: '#edfaff',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Header */}
            <Header />

            {/* Content Wrapper */}
            <div style={{
                flex: '1',
                padding: '2rem 1rem',
                paddingTop: '120px'
            }}>
                {/* Content */}
                <div style={{
                    maxWidth: '800px',
                    margin: '0 auto 3rem',
                    background: '#242A3B',
                    borderRadius: '20px',
                    padding: 'clamp(2rem, 5vw, 3rem)',
                    border: '2px solid #30374A'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                        marginBottom: '2rem'
                    }}>
                        <MessageCircle size={40} color="#007AFF" />
                        <h2 style={{
                            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                            fontWeight: '700',
                            margin: 0,
                            color: '#edfaff'
                        }}>Support</h2>
                    </div>

                    <div style={{ lineHeight: '1.8', color: '#596678' }}>
                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Wie können wir dir helfen?</h3>
                            <p style={{ marginBottom: '1rem' }}>
                                Bei VolleyScout ist uns wichtig, dass du die bestmögliche Erfahrung mit unserer App hast. Egal ob du eine Frage zur Bedienung hast, technische Probleme auftreten oder du Feedback geben möchtest – wir sind für dich da!
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Direkter Kontakt</h3>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Du hast eine spezifische Frage oder brauchst Hilfe? Schreib uns einfach eine E-Mail und wir melden uns so schnell wie möglich bei dir zurück – in der Regel innerhalb von 24 Stunden.
                            </p>

                            {/* Email Button */}
                            <a
                                href="mailto:alex@beitz.me?subject=VolleyScout Support Anfrage"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '0.75rem',
                                    padding: '1rem 2rem',
                                    background: '#007AFF',
                                    color: '#edfaff',
                                    textDecoration: 'none',
                                    borderRadius: '12px',
                                    fontSize: '1.1rem',
                                    fontWeight: '600',
                                    transition: 'all 0.3s ease',
                                    border: 'none',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 20px rgba(0, 122, 255, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#0066DD';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 6px 25px rgba(0, 122, 255, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#007AFF';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 122, 255, 0.3)';
                                }}
                            >
                                <Mail size={24} />
                                Support kontaktieren
                            </a>
                        </section>

                        <section style={{
                            marginTop: '3rem',
                            paddingTop: '2rem',
                            borderTop: '1px solid #30374A'
                        }}>
                            <h3 style={{
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>Kontaktinformationen</h3>
                            <p style={{ margin: '0.5rem 0' }}>
                                <strong style={{ color: '#edfaff' }}>E-Mail:</strong> <a href="mailto:alex@beitz.me" style={{
                                color: '#007AFF',
                                textDecoration: 'none'
                            }}>alex@beitz.me</a>
                            </p>
                        </section>

                        <section style={{
                            marginTop: '2rem',
                            padding: '1.5rem',
                            background: 'rgba(0, 122, 255, 0.1)',
                            borderRadius: '12px',
                            borderLeft: '4px solid #007AFF'
                        }}>
                            <p style={{
                                margin: 0,
                                fontSize: '0.95rem',
                                color: '#edfaff'
                            }}>
                                <strong>💡 Tipp:</strong> Je detaillierter du dein Anliegen beschreibst, desto schneller und präziser können wir dir helfen!
                            </p>
                        </section>

                        {/* FAQ Section */}
                        <section style={{
                            marginTop: '3rem',
                            paddingTop: '2rem',
                            borderTop: '1px solid #30374A'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem'
                            }}>
                                <HelpCircle size={24} color="#43F36F" />
                                Häufig gestellte Fragen (FAQ)
                            </h3>

                            {faqs.map((faq, index) => (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '1rem',
                                        background: '#30374A',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        border: openFaq === index ? '2px solid #007AFF' : '2px solid transparent',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <button
                                        onClick={() => toggleFaq(index)}
                                        style={{
                                            width: '100%',
                                            padding: '1.25rem',
                                            background: 'transparent',
                                            border: 'none',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <span style={{
                                            fontSize: '1.05rem',
                                            fontWeight: '600',
                                            color: '#edfaff',
                                            flex: 1
                                        }}>
                                            {faq.question}
                                        </span>
                                        {openFaq === index ? (
                                            <ChevronUp size={20} color="#007AFF" style={{ flexShrink: 0 }} />
                                        ) : (
                                            <ChevronDown size={20} color="#596678" style={{ flexShrink: 0 }} />
                                        )}
                                    </button>
                                    {openFaq === index && (
                                        <div style={{
                                            padding: '0 1.25rem 1.25rem',
                                            color: '#596678',
                                            lineHeight: '1.6',
                                            animation: 'fadeIn 0.3s ease'
                                        }}>
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Support;